import {Component, Input, OnInit} from '@angular/core';
import {AppState} from '@store/state/app.state';
import {Store} from '@ngrx/store';
import {UserService} from '@iw-shop/user/services/user.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {FormStatus} from '@iw-shop/forms/components/submit-button/submit-button.component';
import {CaptchaService} from "@iw-shop/captcha/services/captcha.service";

@Component({
    selector: 'iw-shop-user-password-lost',
    standalone: false,
    templateUrl: './user-password-lost.component.html',
    styleUrls: ['./user-password-lost.component.scss']
})
export class UserPasswordLostComponent implements OnInit {
    @Input() buttonClass: string = 'is-primary';

    form: FormGroup;
    error: string = '';
    captcha: boolean = false;
    sentTo: string = '';

    formStatus: FormStatus = null;

    constructor(private store: Store<AppState>, private userService: UserService, private fb: FormBuilder) {
        this.form = this.fb.group({
            username: this.fb.control('', [Validators.required])
        });
    }

    ngOnInit(): void {
    }

    setCaptcha($event: boolean) {
        this.captcha = $event;
    }

    submit() {

        this.formStatus = 'loading';


        if (!this.captcha ||
            !this.form.valid) {
            this.formStatus = 'submitForm';
            if (!this.form.valid) {
                this.formStatus = 'submitForm';
                this.error = 'Bitte hinterlegen Sie eine E-Mail-Adresse / Benutzernamen';
            }
            return;
        }

        this.userService.sendEmailVerificationLostPassword(this.form.get('username')?.value).subscribe(
            r => {
                if (r.error?.message) {
                    this.formStatus = 'error';
                    setTimeout(() => {
                        this.formStatus = 'submitForm'
                    }, 1000);
                    this.error = r.error?.message;
                } else if (r.result?.userEmailVerification.data.email) {
                    this.formStatus = 'success'
                    this.form.reset();
                    this.sentTo = r.result?.userEmailVerification.data.email;
                } else {
                    this.formStatus = 'error';
                    setTimeout(() => {
                        this.formStatus = 'submitForm'
                    }, 1000);
                    this.error = 'Es ist ein unbekannter Fehler aufgetreten.'
                }
            }
        )
    }


}
